(function () {

/**
 * Baseclass for all widgets.
 *
 * Provides abstract hooks for child classes.
 *
 * @param properties A map of fields to set. May be new or public fields.
 * @class AbstractWidget
 */
AjaxSolr.AbstractWidget = AjaxSolr.Class.extend(
  /** @lends AjaxSolr.AbstractWidget.prototype */
  {
  /**
   * @param {Object} attributes
   * @param {String} attributes.id A unique identifier of this widget.
   * @param {String} [attributes.target] The CSS selector for this widget's
   *   target HTML element, e.g. a specific <tt>div</tt> or <tt>ul</tt>. A
   *   Widget is usually implemented to perform all its UI changes relative to
   *   its target HTML element.
   * @param {Number} [attributes.start] The offset parameter. Set this field to
   *   make the widget reset the offset parameter to the given value on each
   *   request.
   */
  constructor: function (attributes) {
    AjaxSolr.extend(this, {
      id: null,
      target: null,
      start: undefined,
      // A reference to the widget's manager.
      manager: null
    }, attributes);
  },

  /**
   * An abstract hook for child implementations.
   *
   * <p>This method should do any necessary one-time initializations.</p>
   */
  init: function () {},

  /**
   * An abstract hook for child implementations.
   *
   * <p>This method is executed before the Solr request is sent.</p>
   */
  beforeRequest: function () {},

  /**
   * An abstract hook for child implementations.
   *
   * <p>This method is executed after the Solr response is received.</p>
   */
  afterRequest: function () {},

  /**
   * A proxy to the manager's doRequest method.
   */
  doRequest: function () {
    this.manager.doRequest(this.start,this.target.split(' ')[0].substring(1));
  }
});

})();
